import type { AutocompleteItem } from "./types";

// Transform suggestions into autocomplete items with memoization-friendly structure
export function transformSuggestions<T>(
	suggestions: T[],
	isLoading: boolean,
	inputValue: string,
	isValueSelected: boolean = false,
	loadingText: string = "Searching...",
	noResultsText: string = "No results found",
	transformFn: (suggestion: T) => AutocompleteItem,
): AutocompleteItem[] {
	if (isLoading) {
		return [{ id: "loading", text: loadingText, isPlaceholder: true }];
	}

	if (suggestions.length === 0 && inputValue.trim() && !isValueSelected) {
		return [{ id: "empty", text: noResultsText, isPlaceholder: true }];
	}

	return suggestions.map(transformFn);
}

// Debounce function for input changes
export const createDebounce = <T extends (...args: unknown[]) => void>(
	func: T,
	delay: number,
): ((...args: Parameters<T>) => void) => {
	let timeoutId: NodeJS.Timeout;
	return (...args: Parameters<T>) => {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => func(...args), delay);
	};
};
